/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AdminGetOrganizerBalanceKpiResponseDto { 
    /**
     * Organizer (user) id
     */
    organizerId: string;
    /**
     * ISO 4217 currency code (e.g. EUR)
     */
    currency: string;
    /**
     * Sum of organizer earnings in incoming/in_escrow (cents). Awaiting transfer to available for withdrawal.
     */
    incomingEarnings: number;
    /**
     * Sum of organizer earnings in available status (cents). Eligible for payout.
     */
    availableToWithdraw: number;
    /**
     * Sum of payout requests pending/approved (cents). Awaiting reviewing.
     */
    pendingPayout: number;
    /**
     * Number of events contributing to incomingEarnings
     */
    incomingEventsCount?: number;
}

